<div>
	<section id="main" class="bg-light">
		<div
			id="dashboardContainer"
			class="container"
		>
			<div
				class="overlay"
				*ngIf="isLoading"
			>
				<h1 class="heading" [innerHtml]="'Processing' | translator: 'base'">Processing...</h1>
				<img alt="Loading" />
			</div>
			<h1
				[innerHtml]="'navbar_dashboard_link' | translator: 'base'"
			>Dashboard
			</h1>
			<div class="row">
				<div class="col-12">
					<div
						*ngIf="isOnProbation"
						id="probationInformation"
						class="alert alert-danger"
					>
						<h2
							class=""
							[innerHtml]="'probationModalTextOpener' | translator: 'customer'"
						>Your Account Is In Probation.
						</h2>
						<p>
							<strong
								[innerHtml]="'probationStartLabel' | translator: 'customer'"
							>Probation Start Date:</strong> {{ probationStartDate }} 
						</p>
						<p>
							<strong
								[innerHtml]="'probationEndLabel' | translator: 'customer'"
							>Probation End Date:</strong> {{ probationEndDate }} 
						</p>
						<span [innerHtml]="'probationModalText' | translator: 'customer'">
							During the probation period, your company must submit a legible copy of the driver's disclosure and authorization form
							for each PSP record requested. You will be notified via email
							when each driver disclosure and authorization form is accepted and the driver's PSP record is available to view.
						</span>
					</div>
					<a
						routerLink="/requestRecords"
						class="btn btn-primary btn-strong"
						[title]="'DashboardRequestButton' | translator: 'customer'"
						(click)="scrollToTop()"
						name="btnRecordRequest"
						*ngIf="canRequestRecords"
						id="btnRecordRequest"
					>
						<span
							[innerHtml]="'DashboardRequestButton' | translator: 'customer'"
						>Request Driver Records</span>
					</a>
					<hr>
					<h2
						class="h4"
						[innerHtml]="'DashboardYourRecords' | translator: 'customer'"
					>Your Records</h2>

					<p
						[innerHtml]="'DashboardText1' | translator: 'customer'"
					>PSP records are displayed below for <b>5 days (120 hours)</b> from the time of record request.
					</p>
					<p
						[innerHtml]="'DashboardText2' | translator: 'customer'"
					>Each record may be saved or printed. The search field can help you find a specific record.
					</p>
					<p
						[innerHtml]="'DashboardText3' | translator: 'customer'"
					>To request a motor vehicle record (MVR) for a specific state, the MVR by State link found in the top navigation will take you to a list of the motor vehicle record request websites by state.
					</p>

					<app-dashboardgridsearch (emitter)="send($event)" />

					<div class="card shadow-sm rounded-0 border-0 mb-3">
						<div class="card-body">
							<app-dashboardgrid [searchCriteria]="searchCriteria" />
						</div>
					</div>
        			</div>

				<!-- probation mocal -->
				<ng-template #ProbationModal let-modal>
					<div class="modal-header">
						<h3
							id="probationModalTitle" 
							class="modal-title"
							[innerHtml]="'probationModalTitle' | translator: 'customer'"
						>
							Your Account Is In Probation
						</h3>
					</div>
					<div class="modal-body">
						<p
							[innerHtml]="'probationModalTextOpener' | translator: 'customer'"
						>
							Your Account Is In Probation.
						</p>
						<p>
							<strong
								[innerHtml]="'probationStartLabel' | translator: 'customer'"
							>Probation Start Date:</strong> {{ probationStartDate }} 
						</p>
						<p>
							<strong
								[innerHtml]="'probationEndLabel' | translator: 'customer'"
							>Probation End Date:</strong> {{ probationEndDate }} 
						</p>
						<span [innerHtml]="'probationModalText' | translator: 'customer'">
							During the probation period, your company must submit a legible copy of the driver's disclosure and authorization form
							for each PSP record requested. You will be notified via email
							when each driver disclosure and authorization form is accepted and the driver's PSP record is available to view.
						</span>
					</div>
					<div class="modal-footer">
						<button
							class="btn btn-primary"
							[title]="'OK' | translator: 'base'"
							name="okay"
							(click)="dismissProbationModal()"
						>
							<span
								[innerHtml]="'OK' | translator: 'base'"
							>OK</span>
						</button>
					</div>
				</ng-template>
		
			</div>
			<div class="row">
				<div class="col-12 col-md-6 mb-3 mb-md-0"><app-dashboardnews class="h-100" /></div>
				<div class="col-12 col-md-6"><app-dashboardsupport class="h-100" /></div>
			</div>

		</div>
	</section>

</div>
